import { render, staticRenderFns } from "./homev2.vue?vue&type=template&id=0271d0d8&"
import script from "./homev2.vue?vue&type=script&lang=js&"
export * from "./homev2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports